package ld;

import lib.pathfinder.*;
import ld.Types.Vec2; // I will regret this some day
import pixi.core.sprites.Sprite;
import pixi.core.textures.Texture;
import pixi.core.math.shapes.Rectangle;
import ld.scenes.GameScene;

class GameMap implements IMap
{
	public var rows( default, null ):Int;
	public var cols( default, null ):Int;

	var pathfinder : Pathfinder;

	var bAllowDiagonal = false;
	var bIsMapDynamic = true;
	var eHeuristicType = EHeuristic.PRODUCT;

	var mapTiles: Map<String,Int>;
	var mapTileTints: Map<String,Array<Int>>;
	var mapTileSprites: Map<String,Sprite>;
	var rgWebTiles : Array<String>;
	var pawns: Array<Pawn>;
	

	// Current config
	var pawn: Pawn;
	var rgPawnsToIgnore: Array<Pawn>;
	var bCanWalkOnWater = false;
	var range : Int = 0;
	var scene: GameScene;

	public function new( tileData: Map<String,Int>, pawnData: Array<Pawn>, spriteData: Map<String,Sprite>, p_cols:Int, p_rows:Int, s:GameScene )
	{
		rgWebTiles = new Array<String>();
		scene = s;
		mapTileSprites = spriteData;
		rgPawnsToIgnore = new Array<Pawn>();

		cols = p_cols;
		rows = p_rows;

		mapTiles = tileData;
		pawns = pawnData;
		// create an array of tiles, and determine if they are walkable or obstructed

		pathfinder = new Pathfinder( this ); // Create a Pathfinder engine configured for our map
	}

	public function getRoute( start: Vec2, end: Vec2)
	{
	
		var l_startNode = new Coordinate( start.x, start.y ); // 	The starting node
		var l_destinationNode = new Coordinate( end.x, end.y ); // The destination node
		
		var l_path = pathfinder.createPath( l_startNode, l_destinationNode, eHeuristicType, bAllowDiagonal, bIsMapDynamic );
		if( l_path != null )
			l_path.shift(); // Remove first node; we're already there;
		return l_path;
	}

	public function getRouteToPawn( start: Vec2, target: Pawn )
	{
		
		rgPawnsToIgnore = [ target ];
		
		var l_startNode = new Coordinate( start.x, start.y ); // 	The starting node
		var l_destinationNode = new Coordinate( target.position.x, target.position.y ); // The destination node

		var l_path = pathfinder.createPath( l_startNode, l_destinationNode, eHeuristicType, bAllowDiagonal, bIsMapDynamic );
		if( l_path != null )
			l_path.shift(); // Remove first node; we're already there;
		return l_path;
	}

	public function getMoveTargets( )
	{
		// HNNNG
		// Ok fuck it 
		// do the dumb thing
		var tiles = new Array<Vec2>();
		if( pawn == null )
			return tiles;
		var pos = pawn.position;

		for( x in (pos.x - range)...(pos.x + range+1) )
		{
			for( y in (pos.y - range)...(pos.y + range+1) )
			{
				if( !mapTiles.exists(x + ":" + y) )
					continue;
				
				var route = getRoute( pos, {x: x, y:y} );
				if( route != null && route.length <= range )
					tiles.push({x: x, y:y});
			}
		}

		return tiles;

	}

	public function configureForPawn( other: Pawn )
	{
		bCanWalkOnWater = other.canWalkOnWater();
		range = other.getMoves();
		rgPawnsToIgnore = [];
		pawn = other;
	}
	
	public function isWalkable( p_x:Int, p_y:Int ):Bool
	{
		// Are there any pawns here?
		for( other in pawns )
		{
			if( rgPawnsToIgnore.indexOf(other) != -1 )
			{
				continue;
			}
			if( other != pawn && other.position.x == p_x && other.position.y == p_y && !other.isDead() )
				return false;
		}

		
		// Web tiles are always walkable.
		if( rgWebTiles.indexOf( p_x + ":" + p_y ) != -1 )
			return true;

		var tileID = mapTiles[p_x + ":" + p_y];

		if( pawn != null )
		{
			if( scene.blockedTileIds.indexOf( tileID ) != -1 )
				return pawn.canFly();
			

			if( scene.waterTileIds.indexOf( tileID ) != -1 )
				return pawn.canWalkOnWater() || pawn.canFly();
		}

		return true;
	}

	public function PaintTile( pos: Vec2, color: Int )
	{
		var key = pos.x + ":" + pos.y;
		if( mapTileSprites.exists( key ) )
			mapTileSprites[key].tint = color;
	}

	public function PaintCoordinates( tiles: Array<Coordinate>, color: Int)
	{
		for( tile in tiles)
		{
			PaintTile({x: tile.x, y: tile.y}, color);
		}
	}

	public function UnPaintAllTiles()
	{
		for( x in 0...cols)
		{
			for( y in 0...rows)
			{
				if( !mapTileSprites.exists(x + ":" + y) )
					continue;

				mapTileSprites[x + ":" + y].tint = 0xFFFFFF;
			}
		}
	}

	public function GetPawnForPosition( pos : Vec2, ?includeHeroes: Bool )
	{
		for (pawn in pawns )
		{
			if( ( !pawn.isDead() || ( includeHeroes && pawn.isHero() ) ) && pawn.position.x == pos.x && pawn.position.y == pos.y)
				return pawn;
		}

		return null;
	}

	public function AddWeb( pos: Vec2 ) 
	{
		rgWebTiles.push( pos.x+":"+pos.y );
		var tex = Texture.fromImage("assets/Forest_Logging_Tiles.png");
		var t = new Texture( tex.baseTexture, new Rectangle(128 * 8 ,64 * 3 , 128, 64 ) );
		var webSprite = new Sprite( t );
		webSprite.anchor.y = 1.0;
		scene.containerField.addChild(webSprite);
		return webSprite;
	}	
	
}